import enLang from './locales/en_US/en-US';
import jaLang from './locales/ja_JP/ja_JP';
import viLang from './locales/vi_VN/vi-VN';

const AppLocale = {
  jp: jaLang,
  vi: viLang,
  en: enLang,
};

export default AppLocale;
